"use client";

import React from "react";
import { Grid } from "@mui/material";
import ChatwootChat from "@/lib/services/chatwoot";

const Questions = React.lazy(() => import("./components/Questions"));

export default function Support() {
  return (
    <>
      <Grid container sx={{ mt: "25px", width: "100%", minWidth: 0 }}>
        <Grid
          size={12}
          sx={{
            minWidth: 0,
            pb: { xs: 5, md: 10 },
          }}
        >
          <Questions />
        </Grid>
      </Grid>
      <ChatwootChat />
    </>
  );
}
